import React from 'react';
import CloseIcon from '../../../icons/CloseIcon';
import { styled } from '@mui/material/styles';

const Container = styled('div')({
  height: '56px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 1em',
});

const Text = styled('div')({
  color: '#10416D',
  fontWeight: 'bold',
  textTransform: 'uppercase'
});

const CloseButton = styled('button')({
  cursor: 'pointer',
  display: 'flex',
  background: 'transparent',
  border: '0',
  padding: '0.4em',
});

export default function ParticipantWindowHeader({ closeWindow }: any) {
  return (
    <Container>
      <Text>Participants</Text>
      <CloseButton onClick={() => closeWindow()}>
        <CloseIcon />
      </CloseButton>
    </Container>
  );
}
